import React from 'react';
import TextField from '@material-ui/core/TextField';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import translations from './translations';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Icon from '../Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import styled from 'styled-components';

const StyledTextField = styled(TextField)`
  && {
    .MuiInputBase-root {
      width: 150px;
      margin-right: ${props => props.theme.spacing(1)}px;
      transition: ${props => props.theme.transitions.duration.short}ms
        ${props => props.theme.transitions.easing.easeInOut};

      &.Mui-focused {
        width: 250px;
      }
    }
  }
`;

const DataGridSearch = () => {
  const intl = useIntl();
  const { search: searchModule = {}, showFuzzySearch = true } = useDataSourceContext();
  const { searchValue, setSearchValue, isFuzzy, setIsFuzzy } = searchModule;

  const handleChangeIsFuzzy = e => {
    e.preventDefault();
    setIsFuzzy(!isFuzzy);
  };

  return (
    <StyledTextField
      name="search"
      size="small"
      margin="none"
      variant="outlined"
      autoComplete="off"
      placeholder={intl.formatMessage(translations.search.placeholder)}
      value={searchValue}
      onChange={event => setSearchValue(event.target.value)}
      InputProps={{
        endAdornment: showFuzzySearch && (
          <Tooltip
            title={intl.formatMessage(translations.search.exactMatch, {
              state: intl.formatMessage({
                id: `properties.${isFuzzy ? 'off' : 'on'}`,
                defaultMessage: isFuzzy ? 'off' : 'on',
                description: 'state of the exact match setting',
              }),
            })}
          >
            <IconButton
              size="small"
              onMouseDown={handleChangeIsFuzzy}
              color={isFuzzy ? 'default' : 'primary'}
              style={{ marginRight: -8 }}
            >
              <Icon icon={['fal', 'bullseye-pointer']} size="small" />
            </IconButton>
          </Tooltip>
        ),
      }}
    />
  );
};

export default DataGridSearch;
